<script>
import TestInput from "../../../components/shared/testInput.vue";
import Dropdown from "@/components/dropdown.vue";
export default {
  props: {
    emailTaken: {
      type: Boolean,
      required: false,
      default: false
    },
    pibTaken: {
      type: Boolean,
      required: false,
      default: false
    },
    idTaken: {
      type: Boolean,
      required: false,
      default: false
    },
    usernameTaken: {
      type: Boolean,
      default: false
    },
    type: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({})
    },
    countries: {
      type: Array
    }
  },
  components: {
    InputView: TestInput,
    Dropdown
  },
  data() {
    return {
      confirmPassword: "",
      userLocal: { ...this.user },
      acceptRules: false
    };
  },
  watch: {
    user(val) {
      this.userLocal = { ...val };
      if (val && val.usr_password === null) {
        this.confirmPassword = "";
      }
    },
    acceptRules(val) {
      this.$emit("change-rules", val);
    }
  },
  methods: {
    clearError(field) {
      this.$emit("clear-error", field);
    },
    handlePhoneNumber(field, number, e) {
      const val = number
        .replace(/(?!^\+)[^0-9 ]/g, "")
        .replace(/[ ]{2,}/g, " ");
      this.$set(this.userLocal, field, val);
      e.target.value = val;
      this.updateUser(field);
    },
    updateUser(field) {
      this.clearError(field);
      this.$emit("update", this.userLocal);
    }
  }
};
</script>
<template>
  <div class="register-subpage">
    <!-- <div class="modal-text-wrapper">
      <span v-html="$t('modal.standardRegistrationText')"></span>
      <router-link
        target="_blank"
        :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
        ><span>{{ $t("nav.rules") }}</span></router-link
      >.
    </div> -->
    <div class="inputs">
      <div class="input-wrapper">
        <span class="label">{{ $t("main.inputsRequired") }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_username"
          :label="$t('main.username') + ' *'"
          @input="updateUser('usr_username')"
          max-length="15"
        />
        <span v-if="errors.usr_username" class="error">{{
          $t("errors.registration.username")
        }}</span>
        <span v-if="usernameTaken" class="error">{{
          $t("errors.registration.usernameTaken")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_password"
          type="password"
          :label="$t('main.password') + ' *'"
          @input="updateUser('usr_password')"
        />
        <small>{{ $t("register.passwordRules") }}</small>
        <span v-if="errors.usr_password" class="error">{{
          $t("errors.registration.password")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="confirmPassword"
          type="password"
          :label="$t('main.confirmPassword') + ' *'"
          @input="updateUser('usr_password')"
        />
        <span
          v-if="
            userLocal.usr_password && userLocal.usr_password !== confirmPassword
          "
          class="error"
          >{{ $t("errors.registration.samePasswords") }}</span
        >
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_email"
          :label="$t('main.email') + ' *'"
          @input="updateUser('usr_email')"
        />
        <span v-if="errors.usr_email" class="error">{{
          $t("errors.registration.email")
        }}</span>
        <span v-if="emailTaken" class="error">{{
          $t("errors.registration.emailTaken")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_name"
          :label="
            type ? $t('main.firm') + ' *' : $t('main.nameLastName') + ' *'
          "
          @input="updateUser('usr_name')"
        />
        <span v-if="errors.usr_name" class="error">{{
          type
            ? $t("errors.registration.orgName")
            : $t("errors.registration.name")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_org_full_name"
          :label="$t('main.usr_org_full_name') + (type ? ' *' : '')"
          @input="updateUser('usr_org_full_name')"
        />
        <span v-if="errors.usr_org_full_name" class="error">{{
          $t("errors.registration.usr_org_full_name")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          :value="userLocal.usr_phone_number"
          :label="$t('main.phone') + ' *'"
          @input="(e1, e2) => handlePhoneNumber('usr_phone_number', e1, e2)"
        />
        <span v-if="userLocal.usr_phone_number" class="label">{{
          $t("main.phoneInfo")
        }}</span>
        <span v-if="errors.usr_phone_number" class="error">{{
          $t("errors.registration.phone")
        }}</span>
      </div>
      <div class="input-wrapper" v-if="userLocal.usr_phone_number">
        <InputView
          :value="userLocal.usr_phone_number1"
          :label="$t('main.phone') + ' 2'"
          @input="(e1, e2) => handlePhoneNumber('usr_phone_number1', e1, e2)"
        />
        <span v-if="userLocal.usr_phone_number1" class="label">{{
          $t("main.phoneInfo")
        }}</span>
        <span v-if="errors.usr_phone_number1" class="error">{{
          $t("errors.registration.phone")
        }}</span>
      </div>
      <div class="input-wrapper" v-if="userLocal.usr_phone_number1">
        <InputView
          :value="userLocal.usr_phone_number2"
          :label="$t('main.phone') + ' 3'"
          @input="(e1, e2) => handlePhoneNumber('usr_phone_number2', e1, e2)"
        />
        <span v-if="userLocal.usr_phone_number2" class="label">{{
          $t("main.phoneInfo")
        }}</span>
        <span v-if="errors.usr_phone_number2" class="error">{{
          $t("errors.registration.phone")
        }}</span>
      </div>
      <div class="input-wrapper" v-if="userLocal.usr_phone_number2">
        <InputView
          :value="userLocal.usr_phone_number3"
          :label="$t('main.phone') + ' 4'"
          @input="(e1, e2) => handlePhoneNumber('usr_phone_number3', e1, e2)"
        />
        <span v-if="userLocal.usr_phone_number3" class="label">{{
          $t("main.phoneInfo")
        }}</span>
        <span v-if="errors.usr_phone_number3" class="error">{{
          $t("errors.registration.phone")
        }}</span>
      </div>
      <div class="input-wrapper" v-if="countries">
        <dropdown
          :defaultText="$t('main.country') + ' *'"
          :selected="userLocal.usr_country"
          :list="countries"
          @changeOption="
            (userLocal.usr_country = $event), updateUser('usr_country')
          "
        />
        <span v-if="errors.usr_country" class="error">{{
          $t("errors.registration.country")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_region"
          :label="$t('main.location') + ' *'"
          @input="updateUser('usr_region')"
        />
        <span v-if="errors.usr_region" class="error">{{
          $t("errors.registration.location")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_address"
          :label="$t('main.address') + ' *'"
          @input="updateUser('usr_address')"
        />
        <span v-if="errors.usr_address" class="error">{{
          $t("errors.registration.address")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_postal_code"
          :label="$t('main.usr_postal_code') + ' *'"
          @input="updateUser('usr_postal_code')"
        />
        <span v-if="errors.usr_postal_code" class="error">{{
          $t("errors.registration.usr_postal_code")
        }}</span>
      </div>
      <div class="checkbox-wrapper">
        <input
          autocomplete="off"
          class="info-value"
          type="checkbox"
          id="privacy"
          @change="$emit('update', userLocal)"
          v-model="userLocal.usr_private"
        />
        <label class="info-key" for="privacy">{{
          $t("profile.sugestions.privacyS")
        }}</label>
      </div>
      <div class="checkbox-wrapper">
        <input
          autocomplete="off"
          class="info-value"
          type="checkbox"
          id="newsletter"
          @change="$emit('update', userLocal)"
          v-model="userLocal.usr_newsletter"
        />
        <label class="info-key" for="newsletter">{{
          $t("profile.sugestions.newsletter")
        }}</label>
      </div>
      <div class="checkbox-wrapper">
        <input
          autocomplete="off"
          class="info-value"
          type="checkbox"
          id="notification"
          @change="$emit('update', userLocal)"
          v-model="userLocal.usr_notifications"
        />
        <label class="info-key" for="notification"
          >{{ $t("profile.sugestions.notifications") }}
        </label>
      </div>
      <div class="checkbox-wrapper">
        <input type="checkbox" id="accept-rules" v-model="acceptRules" />
        <label for="accept-rules">
          <span>{{ $t("register.acceptRules.0") }}</span>
          <router-link
            target="_blank"
            :to="{
              name: 'Rules',
              params: { lang: $i18n.locale }
            }"
          >
            {{ $t("nav.rules") }}
          </router-link>
          <span>{{ $t("register.acceptRules.1") + "*" }}</span>
        </label>
      </div>
    </div>
    <div class="action">
      <small v-if="!acceptRules" class="error">{{
        $t("errors.registration.rules")
      }}</small>
      <router-link
        :to="{
          name: 'RegisterPage2',
          params: { lang: $i18n.locale },
          query: { ...$route.query }
        }"
        class="btn dark-blue"
        :class="{ disabled: !acceptRules }"
      >
        {{ $t("register.next") }}
      </router-link>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.register-subpage {
  .btn {
    width: fit-content;
    padding: 10px 30px;
    margin: 20px 0;

    text-decoration: none;

    @media screen and (max-width: 768px) {
      width: inherit;
    }
  }
  .action {
    text-align: left;
  }
  .error {
    color: $red-700;
  }
  .inputs {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 480px;
    .input-wrapper {
      display: flex;
      flex-direction: column;
      gap: 3px;
      align-items: flex-start;
      .dropdown-wrapper {
        width: 100%;
      }
    }
    .checkbox-wrapper {
      display: flex;
      gap: 5px;
      align-items: flex-start;
      text-align: left;
      a {
        color: $light-blue-500;
      }
    }
  }
}
</style>
